<template>
  <v-snackbar v-model="snackbar" :multi-line="multiLine" :timeout="timeout" :color="type" top right>
    {{ text }}
    <template v-slot:action="{ attrs }">
      <v-btn color="white" v-bind="attrs" @click="snackbar = false" text small> Close </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
/* Notifications type values
1) info
2) success
3) warning,
4) error
*/

export default {
  name: 'Notification',
  mounted: function () {},
  data() {
    return {
      multiLine: true,
      snackbar: false,
      timeout: 4000,
      type: 'info',
      text: 'Test',
    };
  },
  methods: {
    showMessage() {
      this.snackbar = true;
    },
  },
  computed: {
    notificationMessage() {
      return this.$store.getters.notificationMessage;
    },
  },
  watch: {
    notificationMessage: function () {
      if (this.notificationMessage) {
        this.type = this.notificationMessage.type;
        this.text = this.notificationMessage.text;
        this.showMessage();
      }
    },
  },
};
</script>

<style lang="scss"></style>
